module.exports = __webpack_public_path__ + "img/thumbnail_ReticulatedGiraffe_j_albino.d24f36a5.png";